import Logger from './Logger'

const END_POINT_PREFIX = 'https://flrjbxwew3.execute-api.us-west-2.amazonaws.com/';
// Uncomment to connect to production endpoints

export const DEV_STAGE = 'dev'
export const PROD_STAGE = 'prod'

const MiscUtils = {

  VERSION_CODE: '23.4',
  STAGE: PROD_STAGE, // DEV_STAGE || PROD_STAGE

  getEndPoint(apiName) {
    return `${END_POINT_PREFIX}${MiscUtils.STAGE}/${apiName}`;
  },

  sendSMSCode(params) {
    return MiscUtils.fetchAPI(MiscUtils.getEndPoint('sendsmscode'),
      params, 'sendSMSCode')
  },

  fetchEndPoint(endPoint, params) {
    return MiscUtils.fetchAPI(MiscUtils.getEndPoint('invokefunction'),
      params, endPoint);
  },

  fetchAPI(url, params, endPoint) {
    const body = {
      stage: MiscUtils.STAGE,
      versionCode: MiscUtils.VERSION_CODE,
      endPoint: endPoint,
      params: params
    }
    Logger.info(`-->> Fetching: ${url} with body:`, body)
    return fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body)
    }).then((response) => response.json())
      .then((responseJson) => {
        Logger.info('responseJson', responseJson)
        if ((responseJson.errorMessage && responseJson.errorMessage !== "No errors") || responseJson.message === "Internal server error") {
          return Promise.reject(responseJson.errorMessage || responseJson.message)
        }
        return responseJson
      })
  }

}

export default MiscUtils



// WEBPACK FOOTER //
// ./src/infra/MiscUtils.js